import { GzPolicyUiSettingsGridItemFormWebComponent } from '../../../../../../../../../common/policyPanel/uiSettings/gridTemplate/form';
import { html, TemplateResult } from 'lit';
import { translateFn } from '../../../../../../../../../../utils/translator.helper';
import { customElement, query } from 'lit/decorators.js';
import { GzFormFieldWebComponent } from '../../../../../../../../../../ui/gzForm/formField';
import { GzInputWebComponent } from '../../../../../../../../../../ui/gzInput/component/GzInputWebComponent';
import { FormGroup } from '../../../../../../../../../../ui/gzForm/formGroup/form-group';
import { WEB_COMPONENT_POLICY_PANEL_ANTIMALWARE_ON_DEMAND_EXCLUSIONS_ITEM } from '../../../../../../../../../../webcomponents.constants';
import { GzDropdownWebComponent } from '../../../../../../../../../../ui/gzDropdown';
import { RequiredValidator } from '../../../../../../../../../../ui/gzForm/validators/required.validator';
import { CustomizableValidator } from '../../../../../../../../../../ui/gzForm/validators/customizable.validator';
import {
  getAntimalwareOnDemandExclusionTaskTypeForDropdown,
  MAX_TASK_PATH_LENGTH,
} from '../../../../../../../utils/uiSettings/antimalware/antimalware.values';
import { AntimalwareOnDemandExclusionTaskType, ModuleId, SectionId } from '@nirvana/shared/dtos/types/policies/common';
import { validatePathByType } from './utils/validators';
import { FontSizes } from '../../../../../../../../../../types/common/types';
import { getSupportLinkForPlatform } from '../../../../../../../utils/links';
import { MaxLengthValidator } from '../../../../../../../../../../ui/gzForm/validators/max-length.validator';

@customElement(WEB_COMPONENT_POLICY_PANEL_ANTIMALWARE_ON_DEMAND_EXCLUSIONS_ITEM)
export class GzAntimalwareOnDemandExclusionsItemFormWebComponent extends GzPolicyUiSettingsGridItemFormWebComponent {
  @query('#taskType')
  taskType: GzFormFieldWebComponent<GzDropdownWebComponent>;

  @query('#path')
  path: GzFormFieldWebComponent<GzInputWebComponent, string>;

  public setError(error: string) {
    this.path.setError(error);
  }

  renderFormFields(): TemplateResult {
    return html`
      <div class="policy-grid-item-form--field">
        <gz-form-field id="taskType">
          <gz-dropdown
            @selectionChanged="${this.handleTypeFieldChange}"
            gz-form-input
            label="${translateFn('Exclusions type')}"
            .options=${getAntimalwareOnDemandExclusionTaskTypeForDropdown()}
            .value=${AntimalwareOnDemandExclusionTaskType.FILE}
          ></gz-dropdown>
        </gz-form-field>
      </div>

      <div class="policy-grid-item-form--field input--w25">
        <gz-form-field id="path">
          <gz-input
            gz-form-input
            label="${translateFn('Files and folders to scan')}"
            placeholder="${translateFn('Enter the path')}"
          ></gz-input>
          <gz-link
            fontSize="${FontSizes.PARAGRAPH_12}"
            href="${getSupportLinkForPlatform(
              { moduleId: ModuleId.ANTIMALWARE, sectionId: SectionId.ANTIMALWARE_ON_DEMAND },
              ['suggestionList']
            )}"
            >${translateFn('View list of suggestions')}</gz-link
          >
        </gz-form-field>
      </div>
    `;
  }

  focusFirstInput(): void {
    this.taskType.Input.updateDropdownState(true);
  }

  private handleTypeFieldChange() {
    this.path.validate();

    switch (this.taskType.value) {
      case AntimalwareOnDemandExclusionTaskType.FILE:
        this.path.Input.placeholder = translateFn('Enter the file path');
        break;
      case AntimalwareOnDemandExclusionTaskType.FOLDER:
        this.path.Input.placeholder = translateFn('Enter the folder path');
        break;
      case AntimalwareOnDemandExclusionTaskType.EXTENSION:
        this.path.Input.placeholder = translateFn('Enter file extensions (for example: jpg, txt, avi, png)');
        break;
    }
  }

  createFormGroup(): void {
    this.taskType.Validators = [RequiredValidator(translateFn('Required field'))];
    this.path.Validators = [
      RequiredValidator(translateFn('Required field')),
      MaxLengthValidator(
        MAX_TASK_PATH_LENGTH,
        translateFn('The path must not exceed {maxLength} characters.', {
          maxLength: MAX_TASK_PATH_LENGTH,
        })
      ),
      CustomizableValidator((value: string) =>
        validatePathByType(this.taskType.value as AntimalwareOnDemandExclusionTaskType, value)
      ),
    ];

    this.formGroup = new FormGroup({
      taskType: this.taskType,
      path: this.path,
    });
  }

  resetForm(resetType = true): void {
    if (resetType) {
      this.taskType.value = AntimalwareOnDemandExclusionTaskType.FILE;
      this.taskType.resetField();
    }

    this.path.value = '';
    this.path.resetField();
  }

  reset() {
    this.resetForm();
  }

  resetOnAdd() {
    this.resetForm(false);
  }
}
